import { centsToInput, counterAmount, parseMoney } from './format';

/** Betrag gleichmäßig auf n Teile; Restcents an die ersten (Summe bleibt exakt). */
export const splitCents = (total: number, n: number): number[] => {
  if (n <= 0) return [];
  const base = Math.floor(total / n);
  return Array.from({ length: n }, (_, i) => base + (i < total - base * n ? 1 : 0));
};

export type BulkRow = {
  /** von Hand eingetragener Nettopreis; null = wird aus dem Gesamtpreis verteilt */
  netManual: string | null;
  /** von Hand eingetragener Bruttopreis; null = netto + 19 % */
  grossManual: string | null;
};

const cents = (s: string | null): number | null => {
  if (s === null) return null;
  const v = parseMoney(s);
  return v === null || Number.isNaN(v) ? null : v;
};

/**
 * Netto/Brutto je Zeile: Zeilen mit eigenem Preis behalten ihn, der Rest des Gesamtpreises
 * wird gleichmäßig auf die übrigen verteilt (wie beim Inventarabgleich). Brutto = netto + 19 %, wenn nicht von Hand.
 */
export const computeBulkPrices = (totalInput: string, rows: BulkRow[]) => {
  const total = cents(totalInput.trim() ? totalInput : null);
  const fixedSum = rows.reduce((s, r) => s + (r.netManual !== null ? (cents(r.netManual) ?? 0) : 0), 0);
  const autoCount = rows.filter((r) => r.netManual === null).length;
  // Bleibt nach den festen Preisen nichts übrig, bekommen die übrigen Geräte keinen Preis (nicht 0,00 €)
  const rest = total !== null ? total - fixedSum : 0;
  const shares = rest > 0 ? splitCents(rest, autoCount) : [];
  let i = 0;
  const out = rows.map((r) => {
    const net = r.netManual ?? (rest > 0 ? centsToInput(shares[i++]!) : '');
    const gross = r.grossManual ?? (net ? counterAmount('net', net) : '');
    return { net, gross, netAuto: r.netManual === null && rest > 0, grossAuto: r.grossManual === null && !!net };
  });
  const sum = out.reduce((s, r) => s + (cents(r.net || null) ?? 0), 0);
  return { rows: out, total, sum, mismatch: total !== null && sum !== total };
};
